import React from 'react';
// import NmcContent from '../../layout/NmcContent';
import PageLayout from '../../layout/PageLayout';
import TruContent from '../../layout/TruContent';

const TruContentPage = () => (
  <PageLayout>
    <TruContent />
  </PageLayout>
);

export default TruContentPage;
